import { render, staticRenderFns } from "./EditRefereeDetails.vue?vue&type=template&id=05e1d2f0&scoped=true"
import script from "./EditRefereeDetails.vue?vue&type=script&lang=js"
export * from "./EditRefereeDetails.vue?vue&type=script&lang=js"
import style0 from "./EditRefereeDetails.vue?vue&type=style&index=0&id=05e1d2f0&prod&scoped=true&lang=css"
import style1 from "./EditRefereeDetails.vue?vue&type=style&index=1&id=05e1d2f0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05e1d2f0",
  null
  
)

export default component.exports